// modules
import { handleActions } from 'redux-actions'

// actions
import { setCompaniesFullList } from 'src/store/modules/admin/ribbonManagement'

const initialState = {
  ribbonList: [],
  companiesFullList: []
}

export default handleActions(
  {
    [setCompaniesFullList](state, { payload: companiesFullList }) {
      return {
        ...state,
        companiesFullList
      }
    }
  },
  initialState
)
